import axios from "axios";

// const localServer = "http://localhost:8080/api";
const herokuServer = "https://json-server-42.herokuapp.com/";

export default axios.create({
  baseURL: herokuServer,
  headers: {
    "Content-type": "application/json",
  },
});
